import functions from './functions.js';

import Slider from "./components/Slider";
import { InputGuests } from "./components/input-guests.js";
import inputPopover from "./components/input-popover.js";
import "./components/gallery.js";
import "./components/datepicker.js";
import "./components/select2.js";
import {FormGuide, FormGuideDefaults} from "./components/form-guide";
import {DeparturePicker} from "./components/departure-picker.js";

$(function() {

    if($('[data-bs-toggle="tooltip"]').length) {
        $('[data-bs-toggle="tooltip"]').tooltip();
    }

    $('.form-guide').each((i, elem) => {
		new FormGuide(elem);
	});

    $('.input-guests').each((i, elem) => {
        elem._inputGuests = new InputGuests(elem);
    });

    inputPopover.apply();

    $('.datepicker.departure-picker [data-input]').each((i, elem) => {
        elem._departurePicker = new DeparturePicker(elem);
    });

    /*let lastScroll = window.scrollY;


    $(window).on('scroll', e => {
        $mainHeader.toggleClass('show', window.scrollY < lastScroll);
        $mainHeader.toggleClass('hide', window.scrollY > lastScroll);
        window.scrollY == 0 && $mainHeader.toggleClass('show', false);
        lastScroll = window.scrollY;
    });*/

    let lastScroll = window.scrollY;

    $(window).on('scroll', e => {
        $('.link-to-top').toggleClass('show', lastScroll > 300);
        //$('.support-sticky').toggleClass('show', lastScroll > 300);
        lastScroll = window.scrollY;

        /*const $detailsBooking = $('.details-booking-wrapper');
        if($detailsBooking.length) {
            const offsetTop = $detailsBooking.offset().top - 500;
            const offsetBottom = offsetTop + $detailsBooking.height() - 300;
            $('.support-sticky').toggleClass('show', $(window).scrollTop() >= offsetTop && $(window).scrollTop() < offsetBottom);
        }*/
    });

    $('.close-bubble').on('click', e => {
        const $target = $(e.currentTarget);
        const $bubble = $target.parents('.support-bubble');
        $bubble.addClass('closed');
    });

    const $mainHeader = $('.main-header');
    const $navMain = $('.nav-main');

    $('#navMainMenu').on('show.bs.collapse', e => {
        $mainHeader.addClass('opened');
        $navMain.addClass('opened');
    });
    $('#navMainMenu').on('hide.bs.collapse', e => {
        $navMain.removeClass('opened');
    });

    if($('#hero-slider')[0]) {
        new Slider($('#hero-slider'), {
            rubberband: false,
            loop: true,
            arrows: true,
            pager: false,
            //autoplay: 5000,
            slides: {
                perView: 1,
                spacing: 0,
            },
            defaultAnimation: {
                duration: 1200,
            },
            /*detailsChanged: (s) => {
              s.slides.forEach((element, idx) => {
                element.style.opacity = s.track.details.slides[idx].portion
              })
            },*/
            //renderMode: "custom",
        });
    }

    let postSlider = [];
    $('[id^=post-slider]').each((i, elem) => {
        const length = $(elem).find('.keen-slider__slide').length;
        postSlider[i] = new Slider('#' + $(elem).attr('id'), {
            rubberband: false,
            loop: false,
            arrows: true,
            pager: false,
            slides: {
                perView: 4,
                spacing: 0,
            },
            breakpoints: {
                '(max-width: 768px)': {
                    slides: {
                        perView: 1.2,
                        spacing: 0,
                    },
                },
            }
        });
    });

    let catalogueSlider = [];
    $('[id^=catalogue-slider]').each((i, elem) => {
        const length = $(elem).find('.keen-slider__slide').length;
        catalogueSlider[i] = new Slider('#' + $(elem).attr('id'), {
            rubberband: false,
            loop: false,
            arrows: true,
            pager: false,
            slides: {
                //origin: "center",
                perView: 4,
                spacing: 0,
            },
            breakpoints: {
                '(max-width: 992px)': {
                    slides: {
                        perView: 2.2,
                        spacing: 0,
                    },
                },
                '(max-width: 576px)': {
                    slides: {
                        perView: 1.2,
                        spacing: 0,
                    },
                },
            }
        });
    });

    if(functions.isMobile()) {

        $('.keen-slider-mobile').addClass('keen-slider');
        $('.keen-slider-mobile').removeClass('row');
        $('.keen-slider__slide-mobile').addClass('keen-slider__slide');

        /*let catalogueSlider = [];
        $('[id^=catalogue-slider]').each((i, elem) => {
            const length = $(elem).find('.keen-slider__slide').length;
            catalogueSlider[i] = new Slider('#' + $(elem).attr('id'), {
                rubberband: false,
                loop: false,
                arrows: true,
                pager: false,
                slides: {
                    //origin: "center",
                    perView: 1.2,
                    spacing: 8,
                }
            });
        });*/

        let navSlider = [];
        $('[id^=nav-slider]').each((i, elem) => {
            const length = $(elem).find('.keen-slider__slide').length;
            navSlider[i] = new Slider('#' + $(elem).attr('id'), {
                rubberband: false,
                loop: false,
                arrows: true,
                pager: false,
                slides: {
                    perView: 1.6,
                    spacing: 0,
                }
            });
        });

        $('[id^=nav-slider]').find('.nav-link').on('shown.bs.tab', e => {
            const $target = $(e.currentTarget);
            const sliderId = $target.parents('[id^=nav-slider]').attr('id');
            let targetId = $target.attr('data-bs-target').replace('#', '');

            navSlider.forEach(slider => {
                if(sliderId == slider.selector.replace('#', '')) {

                    slider.$slides.each((index, slide) => {
                        if($(slide).find('.nav-link').attr('data-bs-target') == '#' + targetId) {
                            slider.instance.moveToIdx(index);
                        }
                    });

                }
            });

            let $slider = $('.tab-pane[id=' + targetId + ']').find('[id^=catalogue-slider]');

            new Slider($slider, {
                rubberband: false,
                loop: false,
                arrows: true,
                pager: false,
                slides: {
                    //origin: "center",
                    perView: 1.2,
                    spacing: 8,
                }
            });
        });
    }

    $('.search-form label').on('click', e => {
        const $target = $(e.currentTarget);
        const $elem = $target.find('.select2-search__field');
        $elem[0] && $elem.focus();
    });

    $(document).on('click', '[data-scroll-to]', e => {
        e.preventDefault();
        const $this = $(e.target);
        let scrollTo = $this.attr('data-scroll-to').split(',');
        functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
    });

    $('.newsletter-form').on('submit', function(e) {
        let $elem = this;
        e.preventDefault();
        e.stopPropagation();

        $($elem).find('.contact-btn').addClass('d-none');
        $($elem).find('.contact-spinner').removeClass('d-none');
        $($elem).find('.newsletter-btn').addClass('d-none');

        grecaptcha.ready(function() {
            grecaptcha.execute('6LeitgwoAAAAALtpc4QpNvflq8PKj2nyN7glm6qu', {action: 'newsletter'}).then(function(token) {
                let params = {};
                $.each($($elem).serializeArray(), function (i, field) {
                    params[field.name] = field.value;
                });
                params['language'] = functions.getLang();

                $.post('/services/mailchimp/', params).then(response => {
                    response = JSON.parse(response);

                    $('#newsletter-modal').modal('show');
                    $("#newsletter-modal .response-output").html(response.data);

                    setTimeout(() => {
                        $('#newsletter-modal').modal('hide');
                        // details contact modal
                        $('#newsletter-modal').modal('hide');
                    }, 4000);

                    $($elem).find('.contact-btn').removeClass('d-none');
                    $($elem).find('.contact-spinner').addClass('d-none');
                    $($elem).find('.newsletter-btn').removeClass('d-none');

                    $elem.reset();
                });
            });
        });
    })

});